module.exports = __webpack_public_path__ + "img/case1-宁波.85111c43.png";